import { useEffect, useState } from "react";

// 경과 시간 표시용 지금 시각 — active 일 때만 1초마다 바뀐다
export default function useNow(active: boolean) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [active]);
  return now;
}
